import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../commonComponents/modal/Modal';
import translate from '../../../commonComponents/translate';

function OrderCompleteModal({ t, onClose }) {
  return (
    <Modal onClose={onClose}>
      <div className="modal-dialog modal-dialog-centered modal-md order-complete" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title">{t('order_popup_header')}</h3>
            <button type="button" onClick={onClose} className="btn-close">
              <span>x</span>
            </button>
          </div>
          <div id="modalBody" className="modal-body members-modal" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <div className="order-message-complete">
              <div className="modal-icone">
                <img src="images/shop/paper-plane.svg" alt="Paper Plane" />
              </div>
              <div className="modal-alert">
                <p>
                  {t('order_popup_bodyFirst')}
                </p>
                <p>
                  {t('order_popup_bodySecond')}
                </p>
              </div>
            </div>
            <div className="modal-buttons">
              <div className="row justify-content-around">
                <div className="col-4">
                  <button
                    type="button"
                    className="btn m-btn--pill btn-secondary"
                    onClick={() => {
                      window.location.href = '/shop';
                    }}
                  >
                    {t('order_popup_buttonBack')}
                  </button>
                </div>
                <div className="col-4">
                  <button type="button" className="btn m-btn--pill btn-dynamic">
                    {t('order_popup_buttonTrack')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

OrderCompleteModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};
OrderCompleteModal.defaultProps = {
  onClose: () => {},
};

export default translate(OrderCompleteModal);
